<template>
  <v-container>
    <apexchart
      type="radialBar"
      :options="options"
      :series="data"
      length="400"
      height="400"
    ></apexchart>
    <div class="d-flex justify-center" v-if="raw">
      <h3>{{ raw }} / {{ total }}</h3>
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'labels', 'title', 'total', 'raw'],
  computed: {
    ...mapGetters({
      _options: 'charts/getGaugeChart',
    }),
    options() {
      const options = { ...this._options };
      options.labels = this.labels;
      // options.title.text = this.title;
      options.colors[0] = this.$vuetify.theme.currentTheme.primary;
      return options;
    },
  },
};
</script>
